/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_TenantInfoVo } from '../models/Wealthlane_TenantInfoVo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CurrentTenantInfoService {

    /**
     * @returns Wealthlane_TenantInfoVo OK
     * @throws ApiError
     */
    public static getApiCustomerApiTenantCurrent(): CancelablePromise<Wealthlane_TenantInfoVo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/tenant/current',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
